import React from "react";
import Navbar from "./components/navbar";
import CreateEnelComponent from "./create/create.component";
import CreateEnelProvider from "./create/provider/create.provider";
import CreateUsedEnelProvider from "./create/used/provider/createUsed.provider";

const EnelAgentPage = () => {
  return (
    <CreateEnelProvider>
      <CreateUsedEnelProvider>
        <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#461E7D] 2xl:overflow-hidden">
          <Navbar />
          <section className="flex h-full w-full items-center justify-center p-0 pt-20">
            <div className="container w-full px-4 py-20 lg:px-20">
              <CreateEnelComponent />
            </div>
          </section>
        </div>
      </CreateUsedEnelProvider>
    </CreateEnelProvider>
  );
};

export default EnelAgentPage;
